// ----------------------------------------------------------------------

export const paths = {
  // minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    login: `/auth/login`
  },
  // DASHBOARD
  dashboard: {
    root: `/dashboard`
  },
  webAdmin: {
    root: `/web-admin`,
    dashboard: `/web-admin/dashboard`,
    members: `/web-admin/members`,
    memberDetail: (id: string | number) => `/web-admin/members/${id}`,
    codeRegistrations: `/web-admin/code-registrations`,
    downloads: `/web-admin/downloads`,
    watermark: `/web-admin/watermark`,
    lectures: `/web-admin/content/lectures`,
    lectureCreate: `/web-admin/content/lectures/new`,
    lectureDetail: (id: string | number) => `/web-admin/content/lectures/${id}`,
    textbooks: `/web-admin/content/textbooks`,
    textbookCreate: `/web-admin/content/textbooks/new`,
    textbookDetail: (id: string | number) => `/web-admin/content/textbooks/${id}`,
    stats: `/web-admin/stats`,
    terms: `/web-admin/terms`,
    revisions: `/web-admin/content/revisions`,
    revisionCreate: `/web-admin/content/revisions/new`,
    revisionDetail: (id: string | number) => `/web-admin/content/revisions/${id}`,
    customerCenter: (resource = 'faqs') => `/web-admin/customer-center/${resource}`,
    customerCenterCreate: (resource: 'faqs' | 'notices' | 'popups') =>
      `/web-admin/customer-center/${resource}/new`,
    customerCenterDetail: (resource: 'faqs' | 'notices' | 'popups', id: string | number) =>
      `/web-admin/customer-center/${resource}/${id}`,
    content: (resource: string) => `/web-admin/content/${resource}`,
    materialCreate: `/web-admin/content/materials/new`,
    materialDetail: (id: string | number) => `/web-admin/content/materials/${id}`
  },
  member: {
    root: `/member`,
    detail: (id: string | number) => `/member/${id}`
  },

  //결제 관리
  payment: {
    root: `/payment`,
    app: `/payment/app`,
    code: `/payment/code`
  },

  //코드 관리
  code: {
    root: `/code`,
    firstLevel: `/code/first-level`,
    secondLevel: `/code/second-level`,
    web: (productType: string) => `/code/web/${productType.toLowerCase().split('_').join('-')}`
  },

  // 앱 전용 코드 생성
  appCode: {
    root: `/app-code`,
    firstLevel: `/app-code/first-level`,
    secondLevel: `/app-code/second-level`
  },

  //문제 등록 관리
  exam: {
    root: `/exam`,

    // 1급
    firstLevelMasterList: `/exam/first-level`,
    firstLevelExamList: (id: string) => `/exam/first-level/${id}`,
    firstLevelExamAdd: (id: string) => `/exam/first-level/${id}/add`,
    firstLevelExamDetail: (examId: string) => `/exam/first-level/exam/${examId}`,
    // 2급
    secondLevelMasterList: `/exam/second-level`,
    secondLevelExamList: (id: string) => `/exam/second-level/${id}`,
    secondLevelExamAdd: (id: string) => `/exam/second-level/${id}/add`,
    secondLevelExamDetail: (examId: string) => `/exam/second-level/exam/${examId}`
  },

  //통계
  statistics: {
    root: `/statistics`
  },

  //약관 관리
  terms: {
    root: `/terms`
  },
  //관리자 계정 관리
  adminAccount: {
    root: `/admin-account`
  },
  // TODO: 임시 페이지 삭제 필요
  //임시 페이지
  temp: {
    root: `/temp`
  },
  page403: '/403',
  page404: '/404',
  page500: '/500'
};
